import { faFaceAwesome } from '@fortawesome/pro-solid-svg-icons'

import { Input } from 'Components/_theme'
import { Icon } from 'Components/Icon/Icon'

import { Heading } from '../Heading/Heading'
import { INPUT_SIZE } from './Input.constants'

export const InputPresentation = () => {
  /* *** Inputs *** */

  const renderInput = () =>
    INPUT_SIZE.map(size => (
      <Input
        contentAfter={<Icon icon={faFaceAwesome} />}
        contentBefore="http://"
        iconLeft={faFaceAwesome}
        isClearable
        isFilled
        size={size}
      />
    ))

  /* *** Disabled Inputs *** */

  const renderInputDisabled = () =>
    INPUT_SIZE.map(size => (
      <Input
        contentAfter={<Icon icon={faFaceAwesome} />}
        contentBefore="http://"
        disabled
        iconLeft={faFaceAwesome}
        isClearable
        isFilled
        size={size}
      />
    ))

  return (
    <div>
      <Heading size={4}>Input:</Heading>

      {/* *** Inputs all sizes *** */}

      <div className="d-flex pt-4 justify-content-evenly">{renderInput()}</div>

      {/* *** Inputs all sizes disabled *** */}

      <div className="d-flex pt-4 justify-content-evenly">
        {renderInputDisabled()}
      </div>
    </div>
  )
}
